import PropTypes from 'prop-types';
import * as React from 'react';
import { TabHeaderInput } from './tab-header-input.component.js';
import { TabHeaderLabel } from './tab-header-label.component.js';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
({
  tabId: PropTypes.string.isRequired,
  inputProps: PropTypes.object,
  disabled: PropTypes.bool
});
const TabHeader = props => {
  const {
      children,
      inputProps = {},
      tabId,
      disabled
    } = props,
    labelProps = _objectWithoutProperties(props, ["children", "inputProps", "tabId", "disabled"]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeaderInput, _extends({
    tabId: tabId,
    disabled: !!disabled
  }, inputProps)), /*#__PURE__*/React.createElement(TabHeaderLabel, _extends({
    tabId: tabId
  }, labelProps), children));
};
export { TabHeader };